<!-- EUSpace Header: gold topbar + white logo/search bar + navy nav -->
<div class="eu-topbar d-none d-md-block">
  <div class="container eu-topbar__inner">
    <span>
      <i class="fas fa-envelope fa-fw" aria-hidden="true"></i>
      library&#64;elizadeuniversity.edu.ng
    </span>
    <span>
      <i class="fas fa-map-marker-alt fa-fw" aria-hidden="true"></i>
      Ilara-Mokin, Ondo State, Nigeria
    </span>
  </div>
</div>

<header id="main-site-header">
  <div class="container h-100 d-flex flex-row flex-wrap align-items-center justify-content-between gapx-3 gapy-2"
       id="main-site-header-container">

    <!-- Logo -->
    <div id="header-left"
         [attr.role]="(isMobile$ | async) ? 'navigation' : 'presentation'"
         [attr.aria-label]="(isMobile$ | async) ? ('nav.main.description' | translate) : null"
         class="h-100 flex-fill d-flex flex-row flex-nowrap justify-content-start align-items-center gapx-3">

      <a class="d-flex align-items-center eu-header-brand my-2 my-md-0"
         routerLink="/home"
         [attr.aria-label]="'home.title' | translate">
        <img id="header-logo"
             src="assets/images/eu-logo.png"
             [attr.alt]="'menu.header.image.logo' | translate"
             class="eu-header-logo" />
        <span class="eu-header-brand__text d-none d-xl-flex flex-column ml-2">
          <span class="eu-header-brand__name">EUSpace</span>
          <span class="eu-header-brand__sub">Elizade University Repository</span>
        </span>
      </a>

    </div>

    <!-- Search + auth menus -->
    <div id="header-right"
         class="h-100 d-flex flex-row flex-nowrap justify-content-end align-items-center gapx-1 ml-auto">
      <ds-themed-search-navbar></ds-themed-search-navbar>
      <div role="menubar" class="h-100 d-flex flex-row flex-nowrap align-items-center gapx-1">
        <ds-themed-lang-switch></ds-themed-lang-switch>
        <ds-context-help-toggle></ds-context-help-toggle>
        <ds-impersonate-navbar></ds-impersonate-navbar>
        <ds-themed-auth-nav-menu></ds-themed-auth-nav-menu>
      </div>

      <!-- Mobile hamburger -->
      <div id="mobile-navbar-toggler" class="d-block d-lg-none ml-3"
           *ngIf="(isMobile$ | async)">
        <button id="navbar-toggler"
                class="btn eu-hamburger"
                type="button"
                (click)="toggleNavbar()"
                [attr.aria-label]="'nav.toggle' | translate"
                aria-controls="collapsible-mobile-navbar"
                [attr.aria-expanded]="!(isNavBarCollapsed$ | async)">
          <span class="fas fa-bars fa-fw fa-xl" aria-hidden="true"></span>
        </button>
      </div>
    </div>

  </div>
</header>
